/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Dob_FutureInputs */

const en_clients_validation_dob_future = /** @type {(inputs: Clients_Validation_Dob_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of birth must be in the past.`)
};

const pt_br2_clients_validation_dob_future = /** @type {(inputs: Clients_Validation_Dob_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A data de nascimento deve ser no passado.`)
};

/**
* | output |
* | --- |
* | "Date of birth must be in the past." |
*
* @param {Clients_Validation_Dob_FutureInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_dob_future = /** @type {((inputs?: Clients_Validation_Dob_FutureInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Dob_FutureInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_dob_future(inputs)
	return pt_br2_clients_validation_dob_future(inputs)
});